import get from 'lodash/get';
import defaultState from '../../state';
import {
  CREATE_NEW_USER,
  CREATE_NEW_USER_SUCCESS,
  CREATE_NEW_USER_FAILED,
  RESET_ALERT_FORM_ERROR,
  SET_ALERT_FORM_ERROR,
  SET_ALERT_SECTION,
} from './actionTypes';
import { ALERT_MODULE_NAME, EMAIL_STATE_NAME } from '../constants';

export const initialState = get(defaultState[ALERT_MODULE_NAME], [EMAIL_STATE_NAME]);

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_NEW_USER:
      return {
        ...state,
        isLoading: true,
        formError: null,
      };

    case CREATE_NEW_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        formError: null,
      };

    case CREATE_NEW_USER_FAILED:
      return {
        ...state,
        isLoading: false,
        formError: action.payload,
      };

    case SET_ALERT_FORM_ERROR:
      return {
        ...state,
        formError: action.payload,
      };

    case RESET_ALERT_FORM_ERROR:
      return {
        ...state,
        formError: null,
      };

    case SET_ALERT_SECTION:
      return {
        ...state,
        section: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/Alerts/email/reducer.js